export default __webpack_public_path__ + "static/media/ny-cityguide-02.791a3214.jpg";